import { InfoOutlined } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { Link } from "react-router-dom";
import SimpleTooltip from "../../Data/SimpleTooltip";

export interface Breadcrumb {
    title: string;
    link: string;
    testId?: string;
}

interface Props {
    title: string;
    testId?: string;

    breadcrumbs?: Breadcrumb[];
    description?: string;

    className?: string;
}

const useStyles = makeStyles(() => ({
    breadcrumbs: {
        fontSize: "14px"
    },
    heading: {
        marginTop: "0.5rem",
        fontSize: "1.5rem",
        fontWeight: 500,
        margin: "0px",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        marginBottom: "0rem",
        display: "flex"
    },
    breadcrumbLink: {
        textDecoration: "none",
        color: "rgba(0, 0, 0, 0.67)",
        "&:hover": {
            textDecoration: "underline"
        }
    },
    breadcrumbLinkFake: {
        color: "rgba(0, 0, 0, 0.67)"
    },
    breadcrumbSeparator: {
        marginLeft: "0.5rem",
        marginRight: "0.5rem",
        color: "rgba(0, 0, 0, 0.67)"
    },
    helpIcon: {
        fontSize: "1.35rem",
        margin: "0.5rem 0 -0.5rem 0.5rem",
        color: "rgba(0, 0, 0, 0.67)"
    }
}));

const QABreadcrumbsHeader: React.FC<Props> = props => {
    const classes = useStyles();

    return (
        <div
            data-cy={`${props.testId}-QABreadcrumbsHeader`}
            className={props.className}>

            <div className={classes.breadcrumbs}>
                {props.breadcrumbs?.map(breadcrumb => (
                    <React.Fragment key={breadcrumb.title}>
                        <Link
                            data-cy={breadcrumb.testId}
                            className={classes.breadcrumbLink}
                            to={breadcrumb.link}>
                            {breadcrumb.title}
                        </Link>

                        <span className={classes.breadcrumbSeparator}>
                            ›
                        </span>
                    </React.Fragment>
                ))}
                <span className={classes.breadcrumbLinkFake}>
                    {props.title}
                </span>
            </div>
            <h1 className={classes.heading}>
                {props.title}
                {props.description && (
                    <SimpleTooltip
                        placement="bottom"
                        title={props.description}>
                        <InfoOutlined className={classes.helpIcon} />
                    </SimpleTooltip>
                )}
            </h1>

        </div>
    );
};

export default QABreadcrumbsHeader;
